export default __webpack_public_path__ + "static/media/SIFA_FR_SEQ03.7f38be46.mp3";